export const useEventStore = defineStore("event", () => {
  const data = reactive({
    city: null,
    admin: null,
    country: null,
    sub: null,
    place: null,

    tags: [],
    type: null,

    activeDates: {},
    canceledDates: {},

    title: null,

    contactMessaging: null,
    contactEmail: null,
    contactPhone: null,
    phone1: null,
    phone2: null,
    email1: null,
    email2: null,
    codePhone1: "FR",
    codePhone2: "FR",

    isOrga: null,
    orgaEmail: null,
    orgaName: null,
    orgaPhone: null,
    orgaCodePhone: "FR",
    userPhone: null,
    userCodePhone: "FR",

    periodicity: null,

    exhMaxCount: null,
    exhInfo: null,
    exhFile: null,
    exhFileUrl: null,
    exhUrl: null,

    paying: null,
    price: null,
    website: null,
    schedule: null,
    description: null,
    loto: null,

    video: null,
    pictures: [],
    picturesUrl: [],

    inside: false,
    outside: false,

    catering: false,
    bar: false,
    parking: false,
    wc: false,
    accessibility: false,
    atm: false,

    selectedLocation: null,

    event: null,
  });

  const progress = ref(0);
  const lastProgress = ref(0);

  const step = ref(useModuleLabel.TAGS);

  const recallAt = ref(null);
  const agendas = [];

  const router = {
    [useModuleLabel.TAGS]: {
      index: 0,
      nextStep: () => useModuleLabel.LOCATION,
    },
    [useModuleLabel.LOCATION]: {
      index: 1,
      prevStep: () => useModuleLabel.TAGS,
      nextStep: () => useModuleLabel.CALENDAR,
    },
    [useModuleLabel.CALENDAR]: {
      index: 2,
      prevStep: () => useModuleLabel.LOCATION,
      nextStep: () => useModuleLabel.ORGANIZER,
    },
    [useModuleLabel.ORGANIZER]: {
      index: 3,
      prevStep: () => useModuleLabel.CALENDAR,
      nextStep: () =>
        data.isOrga ? useModuleLabel.CONTACT : useModuleLabel.REQUIRED,
    },
    [useModuleLabel.CONTACT]: {
      index: 4,
      prevStep: () => useModuleLabel.ORGANIZER,
      nextStep: () => useModuleLabel.REQUIRED,
    },
    [useModuleLabel.REQUIRED]: {
      index: 5,
      prevStep: () =>
        data.isOrga ? useModuleLabel.CONTACT : useModuleLabel.ORGANIZER,
      nextStep: () => useModuleLabel.OPTIONNEL,
    },
    [useModuleLabel.OPTIONNEL]: {
      index: 6,
      prevStep: () => useModuleLabel.REQUIRED,
      nextStep: () => useModuleLabel.RECAP,
    },
    [useModuleLabel.RECAP]: {
      index: 7,
      prevStep: () => useModuleLabel.OPTIONNEL,
      nextStep: () => useModuleLabel.CONFIRM,
    },
    [useModuleLabel.CONFIRM]: { index: 8 },
  };

  const current = computed(() => router[step.value] || null);

  const reset = () => {
    data.selectedLocation = null;

    data.city = null;
    data.admin = null;
    data.country = null;
    data.sub = null;
    data.place = null;

    data.tags = [];
    data.type = null;

    data.activeDates = {};
    data.canceledDates = {};

    data.title = null;

    data.contactMessaging = null;
    data.contactEmail = null;
    data.contactPhone = null;
    data.phone1 = null;
    data.phone2 = null;
    data.email1 = null;
    data.email2 = null;
    data.codePhone1 = "FR";
    data.codePhone2 = "FR";

    data.isOrga = null;
    data.orgaEmail = null;
    data.orgaName = null;
    data.orgaPhone = null;
    data.orgaCodePhone = "FR";
    data.userPhone = null;
    data.userCodePhone = "FR";

    data.periodicity = null;

    data.exhMaxCount = null;
    data.exhInfo = null;
    data.exhFile = null;
    data.exhFileUrl = null;
    data.exhUrl = null;

    data.paying = null;
    data.price = null;
    data.website = null;
    data.schedule = null;
    data.description = null;
    data.loto = null;

    data.video = null;
    data.pictures = [];
    data.picturesUrl = [];

    data.inside = null;
    data.outside = null;

    data.catering = false;
    data.bar = false;
    data.parking = null;
    data.wc = null;
    data.accessibility = false;
    data.atm = false;

    data.event = null;

    step.value = useModuleLabel.TAGS;

    progress.value = 0;
    lastProgress.value = 0;
    agendas.value = [];

    recallAt.value = null;
  };

  return {
    router,
    current,
    data,
    step,
    lastProgress,
    progress,
    agendas,
    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useEventStore, import.meta.hot));
}
